<template>
  <div>
    <TermsFetcher :path="'privacy-policy'" />
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import TermsFetcher from "../terms-fetcher.vue";

@Options({
  title: "E4T: Privacy Policy",
  components: {
    TermsFetcher,
  },
})
export default class extends Vue {}
</script>

<style lang="scss"></style>
